import React from 'react';
import { BackButton } from '../ui';
import { ApprovedCircled } from '../../icons';

const SuccessPage = ({
  message = '',
  backButtonText,
  redirectButtonText,
  handleAssignClick,
  handleBackClick,
}) => {
  return (
    <div className="flex flex-col justify-center items-center gap-5 h-[70vh]">
      <div className="flex flex-col justify-center items-center gap-3.5">
      <ApprovedCircled className={'max-lg:w-[40px]'}/>
        {message}
      </div>
      <div className="flex gap-4 max-lg:flex-col max-lg:flex-col-reverse">
        <BackButton
          className="btn-secondary"
          text={backButtonText}
          handleBackClick={handleBackClick}
        />
        <button
          type="button"
          className="btn-primary text-primary-button"
          onClick={handleAssignClick}
        >
          {redirectButtonText}
        </button>
      </div>
    </div>
  );
};

export default SuccessPage;
